import { HubConnectionBuilder } from '@aspnet/signalr';
import store from '../../../src/store';
class MessageHub {
  constructor() {
    this.client = new HubConnectionBuilder()
      .withUrl(`${store.state.apiBaseURL}/api/message-hub`)
      .build();
  }
  start() {
    this.client.start();
  }
}
export default new MessageHub();
